import React from 'react';
const cuadernillos = [{
  icon: '📘',
  title: 'Tomo 1 — 1° Año: La Vida: Bases, Organización y Diversidad',
  desc: 'Célula, nutrición y ecología básica.'
}, {
  icon: '📗',
  title: 'Tomo 2 — 2° Año: Evolución, Origen de la Vida y Sistema Abierto',
  desc: 'Darwin, genética y biotecnología.'
}, {
  icon: '📙',
  title: 'Tomo 3 — 3° Año: El Cuerpo Humano como Sistema Complejo',
  desc: 'Sistemas, salud y ESI.'
}, {
  icon: '📕',
  title: 'Tomo 4 — 4° Año: Genética Molecular, Biotecnología y Metabolismo',
  desc: 'ADN, duplicación, PCR y CRISPR.'
}, {
  icon: '📔',
  title: 'Tomo 5 — 5° Año: Biodiversidad, Ecosistemas y Problemática Ambiental',
  desc: 'Ecosistemas argentinos y crisis global.'
}, {
  icon: '📓',
  title: 'Tomo 6 — 6° Año: Geología, Evolución Humana y Bioética',
  desc: 'Hominización, salud pública y debate ético.'
}];
export function CuadernillosDetail() {
  return <section className="pt-8 md:pt-10 pb-12 md:pb-20 px-4 bg-white" data-id="element-62">
      <div className="max-w-4xl mx-auto" data-id="element-63">
        <div className="text-center mb-8 md:mb-16" data-id="element-64">
          <h2 className="text-4xl font-black text-brand-dark mb-4" data-id="element-65">
            Lo que recibís
          </h2>
          <div className="inline-block bg-brand-blue text-white font-bold px-6 py-2 rounded-lg text-xl" data-id="element-66">
            📘 SECUNDARIA — 6 Tomos
          </div>
          <p className="text-xl text-gray-600 mt-4 font-medium" data-id="element-67">
            Para docentes de Biología de 1° a 6° año
          </p>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-68">
          {cuadernillos.map((c, i) => <div key={i} className="bg-white border-2 border-gray-100 p-4 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow flex flex-col md:flex-row gap-4 md:gap-6 items-start" data-id="element-69">
              <div className="text-5xl md:text-6xl flex-shrink-0" data-id="element-70">{c.icon}</div>
              <div data-id="element-71">
                <h3 className="text-2xl font-bold text-brand-dark mb-3" data-id="element-72">
                  {c.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-73">
                  {c.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}